<script setup>
import { computed } from 'vue';
import DatePicker from 'vue-datepicker-next';

const props = defineProps({
  modelValue: {
    type: [Date, String, null],
    default: null,
  },
  placeholder: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

const normalizedValue = computed(() => {
  if (!props.modelValue) return null;
  if (props.modelValue instanceof Date) return props.modelValue;

  const parsedDate = new Date(props.modelValue);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
});

const onChange = value => {
  emit('update:modelValue', value || null);
};
</script>

<template>
  <div class="block min-w-0 w-full">
    <DatePicker
      class="block !w-full min-w-0"
      :value="normalizedValue"
      type="date"
      :editable="false"
      :clearable="false"
      value-type="date"
      format="MMM D, YYYY"
      popup-class="!bg-n-surface-2"
      input-class="!flex !h-8 !w-full !items-center !rounded-lg !border !border-n-weak !bg-transparent !px-3.5 !py-1.5 !text-sm !text-n-slate-12 placeholder:!text-n-slate-10 focus:!border-n-brand"
      :placeholder="placeholder"
      @change="onChange"
    />
  </div>
</template>
